<template>
  <div class="search-details">
    <div class="search-topbar">
      <div class="d-flex topbar" v-bind:class="{'hide-min': isExtended}">
        <nav aria-label="breadcrumb" class="mr-auto">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link :to="{name: 'SearchList'}">Mes recherches</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">
              {{search.name}}
            </li>
          </ol>
        </nav>
        
        <div class="dropdown expand-md">
          <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="icon fa fa-cogs"></i>
          </button>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <router-link class="dropdown-item" :to="{name: 'SearchQueries', params: {id: search.searchId}}">
              <i class="icon fa fa-sliders-h"></i> Requêtes
            </router-link>
            <router-link class="dropdown-item" :to="{name: 'SearchMembers', params: {id: search.searchId}}">
              <i class="icon fa fa-users"></i> Utilisateurs
            </router-link>
            <a href="javascript:void(0)" class="dropdown-item" @click="refreshSearch()">
              <span v-show="!isRefreshing"><i class="icon fa fa-sync"></i> Rafraîchir</span>
              <span v-show="isRefreshing"><i class="icon fa fa-sync"></i>  Rafraîchissement...</span>
            </a>
          </div>
        </div>

        <ul class="nav ml-auto collapse-md">
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'SearchQueries', params: {id: search.searchId}}">
              <i class="icon fa fa-sliders-h"></i> Requêtes
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'SearchMembers', params: {id: search.searchId}}">
              <i class="icon fa fa-users"></i> Utilisateurs
            </router-link>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0)" class="nav-link" @click="refreshSearch()">
              <span v-show="!isRefreshing"><i class="icon fa fa-sync"></i> Rafraîchir</span>
              <span v-show="isRefreshing"><i class="icon fa fa-sync"></i>  Rafraîchissement...</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="d-flex topbar hide-sm" v-bind:class="{hide: !isExtended}">
        <nav aria-label="breadcrumb" class="mr-auto">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a @click="close()"><i class="icon fa fa-arrow-left"></i> Retour</a></li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="search-interface">
      <div class="search-status-panel" v-bind:class="{'hide-min': isExtended}">
        <button class="btn status-panel-selection row-1 section-unselected" @click="getSearchItems('None')" v-bind:class="{active: 'None' == currentDecision}">
          <span class="icon fas fa-eye"></span>
          <span class="text">Non triées</span>
          <!-- <span class="count">{{search.decisionsCount['None']}}</span> -->
          <span class="count">({{totalDecisionCount('None')}})</span>
        </button>
        <button class="btn status-panel-selection row-2 section-favorite" @click="getSearchItems('Favorite')" v-bind:class="{active: 'Favorite' == currentDecision}">
          <span class="icon fas fa-heart"></span>
          <span class="text">Mes favoris</span>
          <!-- <span class="count">{{search.decisionsCount['Favorite']}}</span> -->
          <span class="count">({{totalDecisionCount('Favorite')}})</span>
        </button>
        <button class="btn status-panel-selection row-3 section-like" @click="getSearchItems('Like')" v-bind:class="{active: 'Like' == currentDecision}">
          <span class="icon fas fa-thumbs-up"></span>
          <span class="text">Aimés</span>
          <!-- <span class="count">{{search.decisionsCount['Like']}}</span> -->
          <span class="count">({{totalDecisionCount('Like')}})</span>
        </button>
        <!-- <button class="btn status-panel-selection row-4" @click="getSearchItems('Neutral')" v-bind:class="{active: 'Neutral' == currentDecision}">
          <span class="icon fas fa-cloud"></span>
          <span class="text">Neutral</span>
          <span class="count">{{search.decisionsCount['Neutral']}}</span>
        </button> -->
        <button class="btn status-panel-selection row-4 section-dislike" @click="getSearchItems('Dislike')" v-bind:class="{active: 'Dislike' == currentDecision}">
          <span class="icon fas fa-thumbs-down"></span>
          <span class="text">Non retenu</span>
          <!-- <span class="count">{{search.decisionsCount['Dislike']}}</span> -->
          <span class="count">({{totalDecisionCount('Dislike')}})</span>
        </button>
        <!-- <button class="btn status-panel-selection row-6" @click="getSearchItems('Veto')" v-bind:class="{active: 'Veto' == currentDecision}">
          <span class="icon fas fa-trash-alt"></span>
          <span class="text">Veto</span>
          <span class="count">{{search.decisionsCount['Veto']}}</span>
        </button> -->
      </div>

      <div class="search-items">
        <div
          class="spinner-border text-primary"
          role="status"
          v-bind:class="{ hide: isLoading == false }" >
          <span class="sr-only">Chargement en cours...</span>
        </div>

        <div class="no-items-container container" v-bind:class="{ hide: isLoading == true || searchItems.length > 0 }">
          <div class="row">
            <p class="col-12 text-center"><i>Il n'y a pas d'annonces dans cette section.<br />Allez faire un tour dans les autres sections :</i></p>
          </div>
          <div class="row">
            <div class="col-md-3 no-item-button" v-bind:class="{hide: 'None' == currentDecision}">
              <button class="btn status-panel-selection section-unselected" @click="getSearchItems('None')">
                <span class="icon fas fa-eye"></span>
                <span class="text">Non triées</span>
                <!-- <span class="count">{{search.decisionsCount['None']}}</span> -->
                <span class="count">({{totalDecisionCount('None')}})</span>
              </button>
            </div>
            
            <div class="col-md-3 no-item-button" v-bind:class="{hide: 'Favorite' == currentDecision}">
              <button class="btn status-panel-selection section-favorite" @click="getSearchItems('Favorite')">
                <span class="icon fas fa-heart"></span>
                <span class="text">Mes favoris</span>
                <!-- <span class="count">{{search.decisionsCount['Favorite']}}</span> -->
                <span class="count">({{totalDecisionCount('Favorite')}})</span>
              </button>
            </div>
            
            <div class="col-md-3 no-item-button" v-bind:class="{hide: 'Like' == currentDecision}">
              <button class="btn status-panel-selection section-like" @click="getSearchItems('Like')">
                <span class="icon fas fa-thumbs-up"></span>
                <span class="text">Aimés</span>
                <!-- <span class="count">{{search.decisionsCount['Like']}}</span> -->
                <span class="count">({{totalDecisionCount('Like')}})</span>
              </button>
            </div>
            
            <div class="col-md-3 no-item-button" v-bind:class="{hide: 'Dislike' == currentDecision}">
              <button class="btn status-panel-selection section-dislike" @click="getSearchItems('Dislike')">
                <span class="icon fas fa-thumbs-down"></span>
                <span class="text">Non retenu</span>
                <!-- <span class="count">{{search.decisionsCount['Dislike']}}</span> -->
                <span class="count">({{totalDecisionCount('Dislike')}})</span>
              </button>
            </div>

            <div class="col-md-3 no-item-button">
              <router-link :to="{name: 'SearchQueries', params: {id: search.searchId}}">
                <button class="btn status-panel-selection row-4">
                  <span class="icon fa fa-sliders-h"></span>
                  <span class="text">Gérer les requêtes</span>
                </button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="card search-item" v-for="searchItem in searchItems" :key="searchItem.searchItemId" v-bind:class="{active: searchItem == currentSearchItem, seen: isSeen(searchItem.membersDecisions)}">
          <div class="card-title card-header search-item-title" @click="open(searchItem)">
            <a v-bind:href="searchItem.link" target="_blank"><span class="icon fas fa-link"></span></a>
            <h5>
              {{searchItem.metadata.NbRooms}} p - 
              {{searchItem.metadata.NbBedRooms}} ch - 
              {{searchItem.metadata.Surface}} m² - 
              <span v-show="searchItem.metadata.District">{{searchItem.metadata.District}} <i>({{searchItem.metadata.CityName}})</i></span>
              <span v-show="!searchItem.metadata.District">{{searchItem.metadata.CityName}}</span> - 
              <b>{{searchItem.metadata.Price}} &euro;</b>
            </h5>
           </div>

          <div class="row no-gutter container" @click="open(searchItem)">
            <div class="col-md-4 picture-container">
              <img v-bind:src="searchItem.picture" class="card-img-top search-item-picture" />
            </div>
            <div class="col-md-8 info-container">
              <div class="card-body">
                <div class="row">
                    <div class="col-2 info-badge">Surface</div>
                    <div class="col-4"><span class="badge badge-light">{{searchItem.metadata.Surface}} m²</span></div>

                    <div class="col-2 info-badge">Publiée</div>
                    <div class="col-4"><span class="badge badge-light">{{moment(searchItem.firstParsed).lang("fr").fromNow()}}</span></div>
                    <!-- <div class="col-4"><span class="badge badge-light">{{moment(searchItem.firstParsed).format('DD/MM/YYYY hh\\h')}}</span></div> -->
                </div>

                <div class="row">
                    <div class="col-2 info-badge">Prix </diV>
                    <div class="col-4"><span class="badge badge-light">{{parseFloat(searchItem.metadata.Price).toFixed(0)}} €</span></diV>

                    <div class="col-2 info-badge">Prix/m²</diV>
                    <div class="col-4"><span class="badge badge-light">{{parseFloat(searchItem.metadata.PricePerUnit).toFixed(0)}} €/m²</span></diV>
                </div>

                <div class="row">
                    <div class="col-2 info-badge">Ville</diV>
                    <div class="col-4"><span class="badge badge-light">{{searchItem.metadata.CityName}}</span></diV>

                    <div class="col-2 info-badge">Quartier</diV>
                    <div class="col-4"><span class="badge badge-light">{{searchItem.metadata.District}}</span></diV>
                </div>
                
                <div class="row">
                    <div class="col-2 info-badge">Pièces</diV>
                    <div class="col-4"><span class="badge badge-light">{{searchItem.metadata.NbRooms}}</span></diV>

                    <div class="col-2 info-badge">Chambres</diV>
                    <div class="col-4"><span class="badge badge-light">{{searchItem.metadata.NbBedRooms}}</span></diV>
                </div>
                <!-- <p class="card-text text-left search-description">{{searchItem.description}}</p> -->
              </div>
            </div>
          </div>
          <div class="card-footer decision-panel">
            <ul class="list-group list-group-horizontal btn-group">
              <!-- 
                <button 
                  class="list-group-item btn btn-outline-secondary col-md-3" 
                  v-bind:class="{active: isCurrentDecision(searchItem.membersDecisions, 'None')}" 
                  @click="decision(searchItem, 'None')">
                    None 
                    ({{searchItem.membersDecisions.filter(function(el){ return el.decision == 'None' }).length}})
                </button> 
              -->
              <button 
                class="list-group-item btn btn-outline-danger col-4" 
                v-bind:class="{active: isCurrentDecision(searchItem.membersDecisions, 'Dislike')}" 
                @click="decision(searchItem, 'Dislike')">
                  <i class="icon fas fa-thumbs-down"></i> 
                  <span v-show="decisionCount(searchItem, 'Dislike') != 0">({{decisionCount(searchItem, 'Dislike')}})</span>
              </button>
              <button 
                class="list-group-item btn btn-outline-success col-4" 
                v-bind:class="{active: isCurrentDecision(searchItem.membersDecisions, 'Favorite')}" 
                @click="decision(searchItem, 'Favorite')">
                  <i class="icon fas fa-heart"></i> 
                  <span v-show="decisionCount(searchItem, 'Favorite') != 0">({{decisionCount(searchItem, 'Favorite')}})</span>
              </button>
              <button 
                class="list-group-item btn btn-outline-primary col-4" 
                v-bind:class="{active: isCurrentDecision(searchItem.membersDecisions, 'Like')}" 
                @click="decision(searchItem, 'Like')">
                  <i class="icon fas fa-thumbs-up"></i> 
                  <span v-show="decisionCount(searchItem, 'Like') != 0">({{decisionCount(searchItem, 'Like')}})</span>
              </button>
              <!-- <button class="list-group-item btn btn-outline-info col-md-2" v-bind:class="{active: isCurrentDecision(searchItem.membersDecisions, 3)}" @click="decision(searchItem, 'Neutral')">Neutral ({{searchItem.membersDecisions.filter(function(el){ return el.decision == 3 }).length}})</button> -->
              <!-- <button class="list-group-item btn btn-outline-danger col-md-2" v-bind:class="{active: isCurrentDecision(searchItem.membersDecisions, 1)}" @click="decision(searchItem, 'Veto')">Veto ({{searchItem.membersDecisions.filter(function(el){ return el.decision == 1 }).length}})</button> -->
            </ul>
          </div>
        </div>
      </div>

      <div class="search-item-extended" v-bind:class="{active: isExtended}">
        <div class="decision-panel">
          <div class="row">
            <div class="col-4 text-center align-middle">
              <button 
                class="btn btn-outline-danger" 
                v-bind:class="{active: isCurrentDecision(currentSearchItem.membersDecisions, 'Dislike')}" 
                v-bind:disabled="isVoting"
                @click="decision(currentSearchItem, 'Dislike', $event)">
                  <i class="icon fas fa-thumbs-down"></i> 
                  <span v-show="decisionCount(currentSearchItem, 'Dislike') != 0">({{decisionCount(currentSearchItem, 'Dislike')}})</span>
              </button>
            </div>
            <div class="col-4 text-center align-middle">
              <button 
                class="btn btn-outline-success" 
                v-bind:class="{active: isCurrentDecision(currentSearchItem.membersDecisions, 'Favorite')}" 
                v-bind:disabled="isVoting"
                @click="decision(currentSearchItem, 'Favorite', $event)">
                  <i class="icon fas fa-heart"></i> 
                  <span v-show="decisionCount(currentSearchItem, 'Favorite') != 0">({{decisionCount(currentSearchItem, 'Favorite')}})</span>
              </button>
            </div>
            <div class="col-4 text-center align-middle">
              <button 
                class="btn btn-outline-primary" 
                v-bind:class="{active: isCurrentDecision(currentSearchItem.membersDecisions, 'Like')}" 
                v-bind:disabled="isVoting"
                @click="decision(currentSearchItem, 'Like', $event)">
                  <i class="icon fas fa-thumbs-up"></i> 
                  <span v-show="decisionCount(currentSearchItem, 'Like') != 0">({{decisionCount(currentSearchItem, 'Like')}})</span>
              </button>
            </div>
          </div>
        </div>
        <iframe :src="currentSearchItem.link"></iframe>
      </div>
    </div>  
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default{
  name: 'SearchDetails',
  search: null,
  searchItems: null,
  props: ['id', 'itemId'],
  userId: 1,
  currentSearchItem: { membersDecisions: [] },
  isRefreshing: false,
  isExtended: false,
  data () {
    return {
      search: {},
      searchItems: [],
      userId: 1,
      currentSearchItem: {membersDecisions: []},
      currentDecision: 'None',
      isRefreshing: false,
      isExtended: false,
      isLoading: true,
      isVoting: false
    }
  },
  mounted () {
    // axios
    //   .get(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id)
    //   .then(response => (this.search = response.data))

    // axios
    //   .get(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/items/None')
    //   .then(response => (this.searchItems = response.data))

    this.search.searchId = this.$route.params.id;

    this.refreshSearchItems()

    this.userId = this.$store.getters.getUserId;
  },
  methods: {
    backCallback: function(){
      this.close();
    },
    totalDecisionCount: function(decision){
      if(this.search.decisionsCount){
        return this.search.decisionsCount[decision];
      }
      return 0;
    },
    isCurrentDecision: function(userDecisions, decision){
      var vm = this;
      var userDecision = userDecisions.filter(function(uD){ /*console.log(uD.user.userId + " - " + vm.userId);*/ return uD.user.userId == vm.userId })
      if(userDecision.length > 0 && userDecision[0].decision == decision){ return true; }
      return false;
    },
    decisionCount: function(searchItem, decision){
      return searchItem.membersDecisions.filter(function(el){ return el.decision == decision }).length;
    },
    isSeen: function(userDecisions){
      var vm = this;
      var userDecision = userDecisions.filter(function(uD){ return uD.user.userId == vm.userId })
      if(userDecision.length > 0){ return true; }
      return false;
    },
    decision: function(searchItem, userDecision, event){
      var vm = this;

      vm.isVoting = true;
      // console.log("event :");
      // console.log(event)
      // console.log(event.target);
      if(event)
        $(event.target).blur();

      axios
        .put(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/items/' + searchItem.searchItemId + '/decision/' + vm.userId + '?decision=' + userDecision)
        .then(response => {
          var index = vm.searchItems.indexOf(searchItem);
          console.log("index : " + index)
          vm.searchItems.splice(index, 1);
          // vm.search.decisionsCount[userDecision] = vm.search.decisionsCount[userDecision] + 1;
          if(vm.searchItems.length > index)
            vm.currentSearchItem = vm.searchItems[index];
          else
            vm.currentSearchItem = null;


          vm.refreshSearchInfo();
          vm.isVoting = false;
        })
    },
    open: function(searchItem, callback = false){
      var vm = this;
      vm.currentSearchItem = searchItem;
      vm.isExtended = true;
      
      // Add back button
      document.addEventListener("backbutton", this.backCallback, false);

      console.log(searchItem);

      axios
        .put(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/items/' + searchItem.searchItemId + '/seen/' + vm.userId)
        .then(response => {
          console.log(response);
          var index = vm.searchItems.indexOf(searchItem);
          console.log(index);
          // vm.searchItems.splice(index, 1);
          // vm.search.decisionsCount[userDecision] = vm.search.decisionsCount[userDecision] + 1;
          var userDecision = vm.currentSearchItem.membersDecisions.filter(function(uD){ return uD.user.userId == vm.userId })
          if(userDecision.length > 0){
            userDecision[0].isSeen = true;
            console.log("userDecision already exists");
          }else{
            vm.currentSearchItem.membersDecisions.push(response.data);
            console.log("userDecision does not exists");
          }

          vm.searchItems[index] = vm.currentSearchItem;

          console.log("callback : " + callback);
          if(callback){
            var elements = document.getElementsByClassName("search-item active");
            // console.log("elements")
            // console.log(elements)
            if(elements.length > 0){
              console.log("scroll into view")
              elements[0].scrollIntoView();
            }
          }
        })
    },
    getSearchItems: function(decision){
      this.currentDecision = decision;
      this.searchItems = [];
      this.refreshSearchItems();
    },
    refreshSearchItems: function(){
      var vm = this;

      this.isLoading = true;

      axios
        .get(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/items/' + vm.currentDecision)
        .then(response => {
          this.searchItems = response.data

          if(vm.$route.params.itemId && vm.$route.params.itemId > 0){
              console.log("ask to open search Item : " + vm.$route.params.itemId)
            var searchItem = this.searchItems.filter(function(searchItem){ return searchItem.searchItemId == vm.$route.params.itemId; });
            if(searchItem.length > 0){
              console.log("open search Item : " + searchItem[0].searchItemId)
              vm.open(searchItem[0], true);
            }

            this.$route.params.itemId = null;
          }

          vm.refreshSearchInfo();

          this.isLoading = false;
        })
    },
    refreshSearchInfo: function(){
      var vm = this;

      axios
        .get(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id)
        .then(response => (vm.search = response.data))
    },
    refreshSearch: function(){
      var vm = this;
      this.isRefreshing = true;
      axios
        .patch(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/process?forceRefresh=true')
        .then(response => {
          if(response.status == 200)
            console.log("Successfully refresh data");
          else
            console.log("Error while refreshing data");

          vm.refreshSearchItems();
          
          vm.isRefreshing = false;
        })
    },
    close: function(){
      this.isExtended = false;
      document.removeEventListener("backbutton", this.backCallback);
    },
    moment
  }
}
</script>

<style scope>
#app{
  margin-top: 0;  
  overflow-x: hidden;
}

.search-items{
  grid-column: 2;
  max-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 10px;
}

.search-items .no-items-container{
  margin-bottom: 20px;
}

.search-items .no-items-container .no-item-button .btn{
  height: 150px;
  border: 1px solid #aaa;
  width: 100%;
}

.search-items .no-items-container .no-item-button .btn .icon{
  display: block;
  margin-bottom: 8px;
}

.search-items .no-items-container .no-item-button .btn .text{
  display: block;
}

.search-items .no-items-container .no-item-button .btn .count{
  font-style: italic;
  font-size: 13px;
}

.search-items .search-item{
 margin-bottom: 10px;
 margin-left: 5px;
 margin-right: 5px;
}

.search-items .search-item>.no-gutter{
  margin-left: 0;
}

.search-items .search-item.active{
 background: #e2e2e2;
}

.search-items .search-item.seen{
 opacity: 0.7;
}

.search-items .search-item.seen.active{
  opacity: 1 !important;
}

.search-items .search-item .search-item-title{
  padding-top: 10px;
  padding-bottom: 5px;
  cursor: pointer;
  margin-bottom: 4px;
}

.search-items .search-item .search-item-title h5{
  font-size: 1.1rem;
  font-weight: 100;
}

.search-items .search-item .search-item-title h5 b{
  font-weight: bold;
}

.search-items .search-item .search-item-title a{
  float: right;
}

.search-items .search-item .picture-container{
  height: 150px;
  display: inline-block;
  vertical-align: middle;
  padding-left: 0;
}

.search-items .search-item .card-body{
  height: 150px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  cursor: pointer;
}

.search-items .search-item .search-item-picture{
  max-height: 150px;
  cursor: pointer;
}

.search-items .search-item .search-description{
  height: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  /* white-space: nowrap; */
  text-align: justify !important;
  cursor: pointer;
}

.search-items .search-item .info-badge{
  font-size: 12px;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}

.search-items .search-item .badge{
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}


.search-items .search-item .card-footer{
  padding: 0 1.25rem;
  border: 0;
  margin-top: 4px;
}

.search-interface{
  height : calc(100vh - 105px);
  width: 100vw;
  display: grid;
  grid-template-columns: 80px 1fr 1fr;
}

.search-interface .search-status-panel{
  grid-column: 1;
  display: grid;
  height: 100%;
  width: 100%;
  grid-template-rows: repeat(4, 1fr);
  background: white;
}

.search-interface .search-status-panel .status-panel-selection{
  display: block;
  width: 100%;
  height: 100%;
  background: white;
  /*color: gray;*/
  text-align: center;
  border-radius: 0;
}

.search-interface .search-status-panel .status-panel-selection .icon{
  display: block;
  margin-bottom: 10px;
}

.search-interface .search-status-panel .status-panel-selection .text{
  display: block;
  font-size: 11px;
}

.search-interface .search-status-panel .status-panel-selection .count{
  display: block;
  font-size: 11px;
}

.section-unselected{
  color: gray;
}
.section-unselected:hover, .section-unselected.active{
  color: white;
  background: gray !important;
}

.section-like{
  color: #86BA90;
}
.section-like:hover, .section-like.active{
  color: white;
  background: #86BA90 !important;
}

.section-favorite{
  color: #28a745;
}
.section-favorite:hover, .section-favorite.active{
  color: white;
  background: #28a745 !important;
}

.section-dislike{
  color: #dd3d31;
}
.section-dislike:hover, .section-dislike.active{
  color: white;
  background: #dd3d31 !important;
}

.row-1{
  grid-row: 1;
}

.row-2{
  grid-row: 2;
}

.row-3{
  grid-row: 3;
}

.row-4{
  grid-row: 4;
}

.search-item-extended{
  grid-column: 3;
  height: 100%;
  width: 100%;
}

.search-item-extended .decision-panel{
  height: 50px;
  background: white;
}

.decision-panel>.row{
  height: 100%;
  line-height: 50px;
}

.search-item-extended iframe{
  height: calc(100% - 57px);
  width: 100%;
  border: 0px solid #D58936;
}

@media only screen and (min-width: 600px){
  .hide-sm{
    display: none !important;
  }
}

@media only screen and (max-width: 600px) {
  nav.navbar{
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 100;
  }

  .search-topbar{
    position: fixed;
    width: 100%;
    top: 58px;
    z-index: 100;
  }

  .search-interface{
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 70px;
    margin-top: 106px;
  }

  .search-interface .search-status-panel{
    grid-column: 1;
    grid-row: 2;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    position: fixed;
    height: 75px;
    bottom: 0;
    z-index: 10;
  }

  .search-interface .search-status-panel .row-1{
    grid-row: 1;
    grid-column: 1;
  }

  .search-interface .search-status-panel .row-2{
    grid-row: 1;
    grid-column: 2;
  }

  .search-interface .search-status-panel .row-3{
    grid-row: 1;
    grid-column: 3;
  }

  .search-interface .search-status-panel .row-4{
    grid-row: 1;
    grid-column: 4;
  }

  .search-interface .search-items{
    grid-column: 1;
    grid-row: 1;
  }

  .search-items .search-item>.container{
    padding-left: 0;
    padding-right: 0;
  }

  .search-items .search-item .info-container{
    padding-left: 0;
    padding-right: 0;
  }

  .search-items .search-item .picture-container{
    padding-right: 0;
  }

  .search-items .search-item .card-body{
    padding-top: 5px;
    padding-bottom: 5px;
    height: 100px;
  }

  .search-items .search-item .info-badge{
    font-size: 10px;
    padding-left: 0;
  }
  
  .search-item-extended{
    grid-column: 1;
    grid-row: 1;
    display: none;
    -ms-grid-row-span: 2;
  }

  .search-item-extended.active{
    background: white;
    display: block;
    z-index: 2;
  }

  .search-item-extended .decision-panel{
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 100;
    border-top: 2px solid #2c3e50;
    height: 75px;
  }

  .search-item-extended .decision-panel>.row>div{
    line-height: 75px;
  }

  nav{
    position: fixed;
  }

  .search-item-extended iframe{
    /* height: calc(100% - 106px); */
    height: 100%;
    /* margin-top: 106px; */
  }

  .hide-min{
    display: none !important;
  }

  footer, .copyright{
    display: none;
  }

  #app{
    /* padding-bottom: 100px; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchDetails.vue